import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience.jsx";
import Interface from "./components/Interface.jsx";
import Audio from "./components/Audio.jsx";
import { cameraStart } from "./data/CamAnimation.js";
import { Suspense } from "react";
import LoadingScreen from "./LoadingScreen.jsx";

import "./style.css";
import "./reset.css";
import { Loader, useProgress } from "@react-three/drei";
import HumanAudio from "./components/HumanAudio.jsx";
import Cursor from "./functions/Cursor.jsx";

function App() {
  const { progress } = useProgress();

  const [display, setDisplay] = useState(false);

  useEffect(() => {
    if (progress === 100) {
      setTimeout(() => {
        setDisplay(true);
      }, 1000);
    }
  }, [progress]);

  return (
    <>
      <Cursor />
      <Canvas
        flat
        camera={{
          fov: 50,
          near: 0.1,
          far: 200,
          position: cameraStart,
        }}
      >
        <Suspense fallback={<LoadingScreen progress={progress} />}>
          <Experience />
        </Suspense>
      </Canvas>
      <Loader />
      {display ? (
        <>
          <Interface />
          <Audio />
          <HumanAudio />
        </>
      ) : (
        <></>
      )}
    </>
  );
}

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
